<router-outlet></router-outlet>
<!-- this is the actual login popup -->
<app-guest-modal *ngIf="!auth.isAuthenticated() && !sharedService.isVendorLoginUrl
&& !maintenanceModeOn && !sharedService.isCorpSite"></app-guest-modal>

